import { Box, Text, Button } from "@chakra-ui/react";
import { useNavigate } from "react-router-dom";
import { routes } from "config/paths";
import AIProgressWidget from "../AITasks/AIProgressWidget";

export default function AIReviewRelaxPanel({ task }) {
  const navigate = useNavigate();
  return (
    <Box>
      <Text mt={4} fontSize="body.m" fontWeight="bold">
        We are reviewing your selected sources and generating draft answers.
      </Text>
      <Text mt={2} color="gray.500">
        Track progress and analyse gaps in the AI Review dashboard. View drafts within individual requirements.
      </Text>
      <Text mt={2} color="gray.500">
        Remember that drafts will{" "}
        <Text as="span" fontWeight="bold">
          not
        </Text>{" "}
        be applied automatically. Your team need to review each draft to decide what to include and whether further
        data, iteration or detail is needed.
      </Text>

      <Button
        mt={4}
        w="100%"
        variant="primary"
        onClick={() => {
          navigate(`${routes.issbRequirements}?rtab=2`);
        }}
      >
        OK, I'm done here
      </Button>
    </Box>
  );
}
